<template>
    <div class="account-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="account-content">
                        <div class="account-header">
                            <router-link to="/">
                                <img src="../../assets/images/logo.png" height="150" width="150" alt="main-logo">
                            </router-link>
                            <h3>Redefinir Senha</h3>
                        </div>

                        <!-- Token inválido / em falta -->
                        <div v-if="!token" class="alert-error">
                            <span>Link inválido ou expirado. Por favor, solicite um novo link de recuperação.</span>
                            <div class="text-center mt-4">
                                <router-link to="/forget-password" class="default-btn" style="display:inline-block; padding: 15px 30px;">
                                    Novo link
                                </router-link>
                            </div>
                        </div>

                        <template v-else>
                            <!-- Mensagem de sucesso -->
                            <div v-if="successMessage" class="alert-success">
                                <span>{{ successMessage }}</span>
                            </div>

                            <!-- Mensagem de erro -->
                            <div v-if="errorMessage" class="alert-error">
                                <span>{{ errorMessage }}</span>
                            </div>

                            <form v-if="!successMessage" @submit.prevent="handleReset" class="account-wrap">
                                <div class="form-group mb-24 icon">
                                    <input
                                        v-model="newPassword"
                                        type="password"
                                        class="form-control"
                                        placeholder="Nova senha"
                                        required
                                        minlength="6"
                                        :disabled="loading"
                                    >
                                    <img src="../../assets/images/icon/key.svg" alt="key">
                                </div>
                                <div class="form-group mb-24 icon">
                                    <input
                                        v-model="confirmPassword"
                                        type="password"
                                        class="form-control"
                                        placeholder="Confirmar nova senha"
                                        required
                                        minlength="6"
                                        :disabled="loading"
                                    >
                                    <img src="../../assets/images/icon/key.svg" alt="key">
                                </div>
                                <div class="form-group mb-24">
                                    <button type="submit" class="default-btn" :disabled="loading">
                                        <span v-if="loading" class="btn-spinner"></span>
                                        <span v-else>Redefinir senha</span>
                                    </button>
                                </div>
                            </form>

                            <!-- Estado pós-sucesso -->
                            <div v-if="successMessage" class="text-center mt-3">
                                <router-link to="/login" class="default-btn" style="display:inline-block; padding: 15px 30px;">
                                    Ir para o login
                                </router-link>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import authService from '../../services/authService';

export default {
    name: 'ResetPasswordPage',

    data() {
        return {
            token: '',
            newPassword: '',
            confirmPassword: '',
            loading: false,
            successMessage: '',
            errorMessage: '',
        };
    },

    created() {
        // Ler o token da query string: /reset-password?token=xxxxx
        this.token = this.$route.query.token || '';
    },

    methods: {
        async handleReset() {
            this.successMessage = '';
            this.errorMessage = '';

            if (this.newPassword !== this.confirmPassword) {
                this.errorMessage = 'As senhas não coincidem. Por favor, verifique.';
                return;
            }

            this.loading = true;
            try {
                const result = await authService.resetPassword(this.token, this.newPassword);
                this.successMessage = result.message || 'Senha redefinida com sucesso!';

                // Redirecionar para login após 2 segundos
                setTimeout(() => {
                    this.$router.push('/login');
                }, 2000);
            } catch (error) {
                const status = error.response?.status;
                if (status === 400) {
                    this.errorMessage = 'Token inválido ou expirado. Solicite um novo link de recuperação.';
                } else {
                    this.errorMessage = 'Erro ao redefinir a senha. Tente novamente mais tarde.';
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.account-area {
	background-image: url(../../assets/images/account-bg.jpg);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: auto;
	height: 100vh;
}
.account-content {
	max-width: 510px;
	margin: auto;
	background-color: var(--white-color);
	border-radius: 30px;
	padding: 50px;
}
.account-header {
	text-align: center;
	img {
		margin-bottom: 30px;
	}
	h3 {
		margin-bottom: 30px;
		padding-top: 30px;
		border-top: 1px solid #EBF1FF;
		font-size: 20px;
	}
}
.account-wrap {
	.forgot {
		color: #1765FD;
		font-size: 14px;
	}
	.default-btn {
		color: var(--white-color);
		width: 100%;
		padding: 23px 20px;
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .account-area {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .account-content {
        padding: 30px;
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .account-area {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .account-content {
        padding: 30px;
    }
}
</style>
